/*global kakao*/
import React, { Component } from "react";


class KakaoMap extends Component {
    componentDidMount() {
      const script = document.createElement("script");
      script.async = true;
      script.src =
        "https://dapi.kakao.com/v2/maps/sdk.js?appkey=dce3ab75328b59b8755e26d416082995&autoload=false";
      document.head.appendChild(script);
  
      script.onload = () => {
        kakao.maps.load(() => {
          let container = document.getElementById("Mymap");
          let options = {
            center: new kakao.maps.LatLng(37.543596, 127.046395),
            level: 3
          };
  
          const map = new window.kakao.maps.Map(container, options);

          
    //마커가 표시 될 위치
    let markerPosition = new kakao.maps.LatLng(37.543596, 127.046395);

        // 마커를 생성
        let marker = new kakao.maps.Marker({
          position: markerPosition,
        });
          
        
    // 마커를 지도 위에 표시
    marker.setMap(map);

    



    
    let infowindow = new kakao.maps.InfoWindow({
      content: '<div style="font-size:1rem; width:10rem; text-align:center; padding:0.1rem 0;">메이퀸 픽쳐스</div>'
  });
  infowindow.open(map, marker);

       
        });
      };
    }
    render() {
        return(
            <div className="mi-contact-map">
                <div id="Mymap" style={{ width : '100%', height:'100%'}}/>
            </div>

        );
      }
    }
    
  
  export default KakaoMap;